var UrlHelper = /** @class */ (function () {
    function UrlHelper() {
    }
    /**
   * Adds query parameters to given url
   * @param url Url to which options will be added
   * @param options Query parameters to add
   */
    UrlHelper.prototype.addOptionsToUrl = function (url, options) {
        if (options) {
            options.forEach(function (filter) {
                if (url.indexOf('?') > -1) {
                    url += '&';
                }
                else {
                    url += '?';
                }
                url += filter.getParam();
            });
        }
        return url;
    };
    return UrlHelper;
}());
export { UrlHelper };
export var urlHelper = new UrlHelper();
//# sourceMappingURL=url.helper.js.map